import { createIcon } from '../createIcon';
import { ReactComponent as IconCheckCircle } from '../svg/check-circle.svg';

export default createIcon(IconCheckCircle);
